import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { OkAloneService } from 'src/app/ok-alone.service';

import moment from 'moment';
declare var require: any

@Component({
  selector: 'app-activities',
  templateUrl: './activities.component.html',
  styleUrl: './activities.component.scss'
})
export class ActivitiesComponent implements OnInit{

  activities: any;
  filter: any;
  selected: any;  
  group : any;
  worker_id : any;
  search : any;

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(public okService: OkAloneService){}

  ngOnInit(): void {
    this.pagination.page = 1;
    this.selected = { startDate: moment().subtract(1, 'months'), endDate: moment() };
    this.getActivities();
  }

  getActivities(){

    this.updateFilter();

    this.okService.get('activities',this.filter)
    .subscribe((data) => {

      this.activities = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;

      console.log('activities',data.body);

    });

  }

  changePage(){
    this.getActivities();
  }

  updateFilter(){

    this.filter = [];
    this.filter['start'] = this.selected.startDate.format("YYYY-MM-DD");
    this.filter['end'] = this.selected.endDate.format("YYYY-MM-DD");
    this.filter['page'] = this.pagination.page;

    if(this.search){
      this.filter['search'] = this.search;
    }

    if(this.worker_id){
      this.filter['worker_id'] = this.worker_id;
    }

    if(this.group){
      this.filter['group'] = this.group;
    }
  }

  hasFilter(){
    return this.search || this.worker_id || this.group
  }


  clearFilter(){

    this.filter = [];

    this.getActivities();

  }

  export(){

    this.updateFilter();

    this.okService.download("activities/export",this.filter);
  }
}
